import React, { PureComponent, Fragment } from 'react';
import injectSheet from 'react-jss';
import { Typography } from 'antd';
const { Title, Text } = Typography;

import styles from './styles';
//redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function mapStateToProps(state) {
	return {}
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{},
			dispatch
		)
	};
};

@injectSheet(styles)
@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class AdminLayout extends PureComponent {
	state = {
		loading: false

	};

	componentDidMount() {
		
	}

	render() {
		return (
			<div className="gutter-example" style={{ minWidth:1000 }}>
				<p>Bienvenue sur le tableau de bord du Pass Tama'a</p>
			</div >
		);
	}
}
